import { render, staticRenderFns } from "./createBenefitCategory.vue?vue&type=template&id=635c1dc8&"
import script from "./createBenefitCategory.vue?vue&type=script&lang=js&"
export * from "./createBenefitCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports